<template>
  <div class="column is-four-fifth course">
    <div class="media">
      <div class="media-content">
        <p class="title is-4" contenteditable="true" ng-model="course.type">
          {{ course.type }}
        </p>
        <p class="subtitle is-6">
          {{ course.startDate | formatDate }} -
          {{ course.endDate | formatDate }}
        </p>
      </div>
    </div>

    <section class="modal-card-body">
      <div class="field">
        <label class="label">Kursnamn</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Kursnamn"
            v-model="course.type"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Tid</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="text"
            placeholder="H.MM - H.MM"
            v-model="course.time"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-clock"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <label class="label">Platser</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="number"
            placeholder="Antal deltagare"
            v-model.number="course.numberOfParticipants"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-male"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <label class="label">Pris</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="number"
            placeholder="Pris"
            v-model.number="course.price"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-money-bill"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <label class="label">Instruktör</label>
        <div class="control">
          <div class="select">
            <select v-model="course.instructor">
              <option
                :value="ins.value"
                v-for="ins in getLabels()"
                :key="ins.value"
              >
                {{ ins.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Från</label>
            <div class="control">
              <input class="input" type="date" v-model="course.startDate" />
            </div>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">Till</label>
            <div class="control">
              <input
                class="input"
                type="date"
                placeholder="Textarea"
                v-model="course.endDate"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <a class="button is-danger" @click="deleteCourse"> Radera Kurs </a>
        <a class="button is-primary" @click="updateCourse"> Uppdatera Kurs </a>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "CourseSettings",
  props: {
    course: Object,
  },
  data: function () {
    return {
      bookings: [],
      instructors: [],
      extendedFields: false,
    };
  },
  methods: {
    getInstructors: function () {
      axios.get("/api/instructors/").then((response) => {
        this.instructors = response.data;
      });
    },
    getExtendedFields: function () {
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
    getMails() {
      let mail = [
        ...new Set(this.bookings.map((booking) => booking.customer.email)),
      ].toString();
      return mail.replace(/,/g, "; ");
    },
    copyMail() {
      let copyText = document.getElementById("copyMail");
      copyText.select();

      document.execCommand("copy");
    },
    deleteCourse() {
      if (confirm("Vill du verkligen radera kursen?")) {
        axios.delete("/api/courses/" + this.course._id + "/").then(() => {
          this.$emit("reloadCourses");
        });
      }
    },
    updateCourse() {
      axios.put("/api/courses/" + this.course._id + "/", this.course);
    },
    getLabels: function () {
      var labels = this.instructors.map((ins) => ({
        label: ins.first_name + " " + ins.last_name,
        value: ins._id,
      }));
      labels.push({ value: null, label: "Ingen instruktör" });
      return labels;
    },
  },
  created() {
    this.getInstructors();
    this.getExtendedFields();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info {
  text-align: left;
}

.course {
  text-align: left;
}

.input {
  max-width: 30em;
}
</style>